import {useState, useEffect, useRef} from 'react'

import get from 'lodash/get'

import {v4 as uuidv4} from 'uuid'

import classNames from 'classnames'

import styles from './counter.module.sass'
import { random } from 'lodash'

function getRandomUppercaseString(str) {
	let result = ''

	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
	
	for (let i = 0; i < str.length; i++) {
		let charIndex = characters.indexOf(str[i]) - 8
		if (charIndex < 0) {
			charIndex = characters.length + charIndex
		}
		result += characters.charAt(charIndex)
	}
	return result;
}

function getAlphabetPosition(letter) {
	return letter.charCodeAt(0) - 64
}

const Counter = (props) => {
	const digitsRef = useRef(null)
	const counterRef = useRef(null)

	const uuid = 'id_' + uuidv4()
	let suffix = props.end.match(/\D+$/)?.[0] || ''
	let prefix = props.end.match(/^\D+/)?.[0] || ''
	const cssPropName = `num-${uuid}`
	let start = 0
	let end = props.end
	let letters = false

	if (end.match(/^\D+$/)) {
		letters = true
		prefix = ''
		suffix = ''
		// const randomString = []
		// end.split('/').map((str) => {
		// 	randomString.push(getRandomUppercaseString(str))
		// })
		// // randomString.join('/')
		// console.log('start', start)
	} else {
		end = parseInt(end.replace(suffix, '').replace(prefix, ''))
		start = Math.round(end > 45 ? end - (10 + 35 * Math.random()) : 0)
	}

	function animate() {
		if (letters) {
		} else {
			digitsRef.current.classList.add('animate')
		}
	}

	useEffect(() => {
		function obCallback(e) {
			if (get(e, '[0].isIntersecting')) {
				animate()
				ob.disconnect()
			}
		}
		const ob = new IntersectionObserver(obCallback, {
			threshold: 1.0,
		})
		if (counterRef.current) {
			ob.observe(counterRef.current)
		}
		window.addEventListener('resize', animate)
	}, [])

	return <div ref={counterRef} style={props.style} className={styles.counter}>
		<div ref={digitsRef} className={styles.digits} id={uuid} style={{width: props.end.length * 50 + 'px'}}>{prefix}<span>{letters ? end : ''}</span>{suffix}</div>
		{!letters && <style>{`
			@property --${cssPropName} {
				syntax: '<integer>';
				initial-value: ${start};
				inherits: false;
			}
			#${uuid} {
				transition: --${cssPropName} ${1.5 + props.delay}s;
				counter-reset: ${cssPropName} var(--${cssPropName});
			}
			.animate#${uuid} {
				--${cssPropName}: ${end};
			}
			#${uuid} span::after {
				content: counter(${cssPropName}${letters ? ', upper-alpha' : ''});
			}
		`}</style>}
	</div>
}

export default Counter